export const LOCAL_URL = "https://api.ivisit.io";
// export const LOCAL_URL = "http://localhost:3001";

export const CDN_URL = "https://ivisit-cdn.azureedge.net/ivisit-media/";
